import React from 'react';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';

import DurationComparison from '../DurationComparison';
import GenderEthnicLanguageDiversity from '../GenderEthnicLanguageDiversity';
import LgbtRatioComparision from '../LgbtRatioComparision';
import UnemploymentRate from '../UnemploymentRate';

const TurnoverEmployementStatistics = ({
  jobTitle,
  employmentOverTime,
  unemploymentRateContentBlurb,
  filterLogEventCallback,
  filterValueRange,
  durations,
  yearsAtCurrentJobContentBlurb,
  lgbt,
  lgbtSkewTitles,
  lgbtRatioContentBlurb,
  languagePieChart,
  foreignLanguageContentBlurb,
}) => {
  const durationsRangePresent = durations && durations.range && durations.range.length > 0;
  const lgbtRatioComparisionPresent = lgbt && lgbtSkewTitles && lgbtSkewTitles.length > 0;

  return (
    <section id="gender-statistics" className="w-730">
      <h2 className="brandonH2 w-730 z-mb-48">{`${jobTitle} Turnover And Employment Statistics`}</h2>

      {employmentOverTime && employmentOverTime.length > 0 && (
        <>
          <UnemploymentRate
            jobTitle={jobTitle}
            employmentOverTime={employmentOverTime}
            unemploymentRateContentBlurb={unemploymentRateContentBlurb}
          />
          <div className="section-separator-medium" />
        </>
      )}

      {durationsRangePresent && (
        <DurationComparison
          filterLogEventCallback={filterLogEventCallback}
          filterValueRange={filterValueRange}
          jobTitle={jobTitle}
          durations={durations.range}
          yearsAtCurrentJobContentBlurb={yearsAtCurrentJobContentBlurb}
        />
      )}

      {lgbtRatioComparisionPresent && (
        <>
          <div className="section-separator-medium" />
          <LgbtRatioComparision
            filterLogEventCallback={filterLogEventCallback}
            filterValueRange={filterValueRange}
            lgbt={lgbt}
            jobTitle={jobTitle}
            lgbtSkewTitles={lgbtSkewTitles}
            contentBlurb={lgbtRatioContentBlurb}
          />
        </>
      )}

      {languagePieChart && (
        <GenderEthnicLanguageDiversity
          jobTitle={jobTitle}
          foreignLanguageContentBlurb={foreignLanguageContentBlurb}
          pieChartData={[languagePieChart]}
          filterLogEventCallback={filterLogEventCallback}
          filterValueRange={filterValueRange}
        />
      )}
    </section>
  );
};

export default TurnoverEmployementStatistics;
